import { ChangeLogType, DeletionLog } from "../models/ChangeLog";
import instance from "./instance";

function getDeletionLogs(): Promise<DeletionLog[]> {
    return instance.get(`deletion-logs`).then((response) => {
        return response.data;
    });
}
function restoreItem(id: string): Promise<boolean> {
    return instance.get(`deletion-logs/${id}/restore`).then((response) => {
        return response.data;
    });
}
function restoreItemByExternalId(externalId: string, type: ChangeLogType): Promise<boolean> {
    return instance.get(`deletion-logs/restore?externalId=${externalId}&type=${type}`).then((response) => {
        return response.data;
    });
}
export {getDeletionLogs, restoreItem, restoreItemByExternalId};